/**
 * Class selected value of the dropdown
 */

export class SelectedValue {
  /**
     * Create an object from selected dropdown value
     * @param {Number} id - id of the selected item
     * @param {String} value - text value of the selection
     * @param {String} additionalValue - in case of 'Other' selection store custom value
     */

  constructor (id, value, additionalValue) {
    this.id = id
    this.value = value
    this.additionalValue = additionalValue
  }

  get id () {
    return this._id
  }

  set id (value) {
    if (value) this._id = Number(value)
    else this._id = null
  }

  get value () {
    return this._value
  }

  set value (value) {
    if (value) this._value = String(value)
    else this._value = null
  }

  get additionalValue () {
    return this._additionalValue
  }

  set additionalValue (value) {
    if (value) this._additionalValue = String(value)
    else this._additionalValue = null
  }

  toJSON () {
    return {
      id: this._id,
      value: this._value,
      additionalValue: this._additionalValue
    }
  }
}
